import SummaryCard from "./SummaryCard";

import { CreditCard, Package, ShoppingCart, Store } from "lucide-react";
import { useTranslation } from "react-i18next";

const SaleSummaryCards = ({
  totalSales,
  totalRevenue,
  averagePackagePrice,
  activeStores,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-4">
      <SummaryCard
        title={t(
          "extendedWarranty.reports.summary.totalSales",
          "Toplam Satış Adedi",
        )}
        value={totalSales || 0}
        icon={ShoppingCart}
      />
      <SummaryCard
        title={t("extendedWarranty.reports.summary.totalRevenue", "Toplam Ciro")}
        value={totalRevenue || 0}
        icon={CreditCard}
        isCurrency={true}
      />
      <SummaryCard
        title={t(
          "extendedWarranty.reports.summary.averagePackagePrice",
          "Ortalama Paket Fiyatı",
        )}
        value={averagePackagePrice || 0}
        icon={Package}
        isCurrency={true}
      />
      <SummaryCard
        title={t(
          "extendedWarranty.reports.summary.activeStoreCount",
          "Aktif Mağaza Sayısı",
        )}
        value={activeStores || 0}
        icon={Store}
        description={t(
          "extendedWarranty.reports.summary.activeStoreDescription",
          "Satış yapan mağaza sayısı",
        )}
      />
    </div>
  );
};

export default SaleSummaryCards;
